const ROOTS = {
  AUTH: '/auth',
  DASHBOARD: '/dashboard',
};

// ----------------------------------------------------------------------

export const paths = {
  page403: '/error/403',
  page404: '/error/404',
  page500: '/error/500',
  auth: {
    jwt: {
      signIn: `${ROOTS.AUTH}/jwt/sign-in`,
      forgotPassword: `${ROOTS.AUTH}/jwt/forgot-password`,
      resetPassword: `${ROOTS.AUTH}/jwt/reset-password`,
    },
  },
  // DASHBOARD
  dashboard: {
    root: ROOTS.DASHBOARD,
    general: {
      app: `${ROOTS.DASHBOARD}/app`,
    },
    statistics: {
      root: `${ROOTS.DASHBOARD}/statistics`,
    },
    // KAN-746 — the push reminders: rules and statistics.
    reminders: {
      root: `${ROOTS.DASHBOARD}/reminders`,
    },
    marketing: {
      root: `${ROOTS.DASHBOARD}/marketing`,
    },
    // KAN-755 — where users come from (landing click → install → account).
    acquisition: {
      root: `${ROOTS.DASHBOARD}/acquisition`,
    },
    ops: {
      root: `${ROOTS.DASHBOARD}/ops`,
    },
    moderation: {
      root: `${ROOTS.DASHBOARD}/moderation`,
    },
    enterprise: {
      root: `${ROOTS.DASHBOARD}/enterprise/list`,
      list: `${ROOTS.DASHBOARD}/enterprise/list`,
      create: `${ROOTS.DASHBOARD}/enterprise/create`,
      edit: (id: string) => `${ROOTS.DASHBOARD}/enterprise/edit/${id}`,
    },
    location: {
      root: `${ROOTS.DASHBOARD}/location/map`,
      map: `${ROOTS.DASHBOARD}/location/map`,
      list: `${ROOTS.DASHBOARD}/location/list`,
      create: `${ROOTS.DASHBOARD}/location/create`,
      edit: (id: string) => `${ROOTS.DASHBOARD}/location/edit/${id}`,

      marker: {
        root: `${ROOTS.DASHBOARD}/location/marker/list`,
        list: `${ROOTS.DASHBOARD}/location/marker/list`,
        create: `${ROOTS.DASHBOARD}/location/marker/create`,
        edit: (id: string) => `${ROOTS.DASHBOARD}/location/marker/edit/${id}`,
      },
    },
    appUser: {
      root: `${ROOTS.DASHBOARD}/app-user/list`,
      list: `${ROOTS.DASHBOARD}/app-user/list`,
      suggested: `${ROOTS.DASHBOARD}/app-user/suggested`,
      // KAN-747 — who has not consented to geolocation, and a way to nudge them.
      withoutLocation: `${ROOTS.DASHBOARD}/app-user/without-location`,
      edit: (id: string) => `${ROOTS.DASHBOARD}/app-user/edit/${id}`,
      // KAN-538: per-user analytics detail (activity, level history, posts).
      detail: (id: string) => `${ROOTS.DASHBOARD}/app-user/detail/${id}`,
    },
    adminUser: {
      root: `${ROOTS.DASHBOARD}/admin-user/list`,
      list: `${ROOTS.DASHBOARD}/admin-user/list`,
      create: `${ROOTS.DASHBOARD}/admin-user/create`,
      edit: `${ROOTS.DASHBOARD}/admin-user/edit`,
    },
    reports: {
      root: `${ROOTS.DASHBOARD}/reports/trainings`,
      trainings: `${ROOTS.DASHBOARD}/reports/trainings`,
      trainingDetail: (id: string) => `${ROOTS.DASHBOARD}/reports/trainings/${id}`,
      places: `${ROOTS.DASHBOARD}/reports/places`,
      users: `${ROOTS.DASHBOARD}/reports/users`,
      userDetail: (id: string) => `${ROOTS.DASHBOARD}/reports/users/${id}`,
    },
    feedback: {
      root: `${ROOTS.DASHBOARD}/feedback/account-deletion`,
      accountDeletion: `${ROOTS.DASHBOARD}/feedback/account-deletion`,
    },
    support: {
      root: `${ROOTS.DASHBOARD}/support/tickets`,
      tickets: `${ROOTS.DASHBOARD}/support/tickets`,
    },
    // Debug tools for the founders/QA — the explore matching debugger, split
    // into three pages: the map (locations + radii), one viewer's deck
    // explained, and the OnFit / Match graph.
    debug: {
      root: `${ROOTS.DASHBOARD}/debug/explore/map`,
      explore: {
        root: `${ROOTS.DASHBOARD}/debug/explore/map`,
        map: `${ROOTS.DASHBOARD}/debug/explore/map`,
        deck: `${ROOTS.DASHBOARD}/debug/explore/deck`,
        matches: `${ROOTS.DASHBOARD}/debug/explore/matches`,
        mapViewer: (id: string) => `${ROOTS.DASHBOARD}/debug/explore/map?viewer=${id}`,
        mapPair: (viewerId: string, targetId: string) =>
          `${ROOTS.DASHBOARD}/debug/explore/map?viewer=${viewerId}&target=${targetId}`,
        deckViewer: (id: string) => `${ROOTS.DASHBOARD}/debug/explore/deck?viewer=${id}`,
        deckPair: (viewerId: string, targetId: string) =>
          `${ROOTS.DASHBOARD}/debug/explore/deck?viewer=${viewerId}&target=${targetId}`,
      },
    },
    communications: {
      root: `${ROOTS.DASHBOARD}/communications/list`,
      list: `${ROOTS.DASHBOARD}/communications/list`,
      create: `${ROOTS.DASHBOARD}/communications/create`,
      edit: (id: string) => `${ROOTS.DASHBOARD}/communications/edit/${id}`,
      detail: (id: string) => `${ROOTS.DASHBOARD}/communications/${id}`,
    },
    publicity: {
      root: `${ROOTS.DASHBOARD}/publicity/list`,
      list: `${ROOTS.DASHBOARD}/publicity/list`,
      create: `${ROOTS.DASHBOARD}/publicity/create`,
      edit: (id: string) => `${ROOTS.DASHBOARD}/publicity/edit/${id}`,
    },
    // KAN-788 — the website's event pages (onfitapp.com/evenements).
    siteEvents: {
      root: `${ROOTS.DASHBOARD}/site-events/list`,
      list: `${ROOTS.DASHBOARD}/site-events/list`,
      create: `${ROOTS.DASHBOARD}/site-events/create`,
      edit: (id: string) => `${ROOTS.DASHBOARD}/site-events/edit/${id}`,
    },
  },
};
